import { v4 as uuidv4 } from 'uuid'

export interface StartupUpload {
  id?: string,
  name: string,
  created: Date,
  description?: string,
  contact_name?: string,
  contact_email?: string,
  company_email?: string,
  company_phone?: string,
  company_website?: string,
  logo_url?: string,
  deck_url?: string,
  video_url?: string
  naics_code?: number
}

export interface QuestionGroupScore {
  score: number,
  id: string,
  name: string
}

export interface CommercialViabilityScore {
  score: number
  question_group_scores: QuestionGroupScore[]
  pitch_deck_quality: number
}

class Startup {
  name: string
  id?: string
  description: string
  logoUrl?: string
  createdDate: Date
  contactName?: string
  contactEmail?: string
  companyWebsite?: string
  companyEmail?: string
  companyPhone?: string
  commercialViabilityScore?: CommercialViabilityScore
  userCommercialViabilityScore?: CommercialViabilityScore
  deckUrl?: string
  videoUrl?: string
  naics?: number

  static emptyStartups = (count: number = 1) => {
    const results: Startup[] = []
    for (let i = 0; i < count; ++i) {
      results.push(new Startup(uuidv4(), '', '', undefined, new Date(), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined))
    }
    return results
  }

  constructor (
    id: string | undefined, 
    name: string, 
    description: string, 
    logoUrl: string | undefined, 
    createdDate: Date, 
    contactName?: string,
    contactEmail?: string,
    companyWebsite?: string,
    companyEmail?: string,
    commercialViabilityScore?: CommercialViabilityScore,
    userCommercialViabilityScore?: CommercialViabilityScore,
    companyPhone?: string,
    deckUrl?: string | undefined,
    videoUrl?: string,
    naics?: number
  ) {
    this.name = name
    this.id = id
    this.logoUrl = logoUrl
    this.createdDate = createdDate
    this.description = description
    this.contactName = contactName
    this.contactEmail = contactEmail
    this.companyWebsite = companyWebsite
    this.companyEmail = companyEmail
    this.commercialViabilityScore = commercialViabilityScore
    this.userCommercialViabilityScore = userCommercialViabilityScore
    this.companyPhone = companyPhone
    this.deckUrl = deckUrl
    this.videoUrl = videoUrl
    this.naics = naics
  }
}

export interface StartupResults {
  total_count: number
  startups: Startup[]
}

export default Startup
